"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryString = void 0;
var react_router_dom_1 = require("react-router-dom");
/**
 * Hook that returns an object of query string parameters and values.
 *
 * @return an object whose keys/values are search param keys/values from the URL
 *
 * @category Hook
 */
var useQueryString = function () {
    var search = (0, react_router_dom_1.useLocation)().search;
    var noQuestion = search;
    if (noQuestion.startsWith('?'))
        noQuestion = noQuestion.substr(1);
    var params = noQuestion.split('&');
    var ret = {};
    params.forEach(function (param) {
        var keyVal = param.split('=', 2);
        if (keyVal.length > 1) {
            ret[keyVal[0]] = decodeURI(keyVal[1]);
        }
    });
    return ret;
};
exports.useQueryString = useQueryString;
